import React from 'react';
import { Home, Search, HelpCircle, Phone } from 'lucide-react';
export function MobileStickyBar() {
  const focusSearch = () => {
    const el = document.getElementById('mobile-search') as HTMLInputElement | null;
    if (el) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      el.focus();
    }
  };
  return <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-brand-border shadow-[0_-10px_20px_rgba(9,46,37,0.05)] z-50 pb-safe" data-id="element-610" data-mp="2k2dnf168ah17">
      <div className="flex justify-around items-center h-16" data-id="element-611" data-mp="2b0nyc1ztju6l">
        <a href="#shop-by-need" aria-label="Shop by need" className="flex flex-col items-center justify-center w-full h-full text-brand-charcoal hover:text-brand-maroon transition-colors active:bg-brand-panel" data-id="element-612" data-mp="1waq69ayrqkc4">
          <Home size={22} className="mb-1" data-id="element-613" data-mp="1nbbem86v83q1" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-614" data-mp="1rblvwh03ygk7">
            Shop
          </span>
        </a>
        <button type="button" onClick={focusSearch} aria-label="Search products" className="flex flex-col items-center justify-center w-full h-full text-brand-charcoal hover:text-brand-maroon transition-colors border-l border-brand-border/50 active:bg-brand-panel" data-id="element-615" data-mp="3kmwx8m5fwmg1">
          <Search size={22} className="mb-1" data-id="element-616" data-mp="3pnko97to53a9" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-617" data-mp="3pkgfdx59djd9">
            Search
          </span>
        </button>
        <a href="/ContactUs.html" aria-label="Get help" className="flex flex-col items-center justify-center w-full h-full text-brand-charcoal hover:text-brand-maroon transition-colors border-l border-brand-border/50 active:bg-brand-panel" data-id="element-618" data-mp="2wy3vua61tme1">
          <HelpCircle size={22} className="mb-1" data-id="element-619" data-mp="2j6h1wgzkwpyf" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-620" data-mp="2j55xqg281g6s">
            Help
          </span>
        </a>
        <a href="tel:301-620-7585" aria-label="Call 301-620-7585" className="flex flex-col items-center justify-center w-full h-full text-brand-maroon hover:text-brand-maroonDark transition-colors border-l border-brand-border/50 active:bg-brand-panel" data-id="element-621" data-mp="2e745b4iwo4in">
          <Phone size={22} className="mb-1" data-id="element-622" data-mp="3cod26let8hwc" />
          <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-623" data-mp="3hmn033rx5wln">
            Call
          </span>
        </a>
      </div>
    </div>;
}